export const campaignConfig = {
    mass: 'campaign_aia_mass',
    mass_am: 'campaign_aia_mass_am',
    prestige: 'campaign_aia_prestige',
    prestige_am: 'campaign_aia_prestige_am'
};

export const dashboardConfig = {
    mass: 'aia_home_mass',
    mass_am: 'aia_home_mass_am',
    prestige: 'aia_home_prestige',
    prestige_am: 'aia_home_prestige_am'
};

export const categoryConfig = {
    mass: 'menu_aia_mass',
    mass_am: 'menu_aia_mass_am',
    prestige: 'menu_aia_prestige',
    prestige_am: 'menu_aia_prestige_am',
    menuCategoryImgUrl: '/aia/category/'
};

export const historyConfig = {
    purchase: 'purchase',
};
